export const isValidEmail = email => {
  const pattern = /^[^\s@]+@[^\s@]+\.(com|org|net|edu|gov|mil|co|uk|io|dev|xyz|info|me)$/;
  return pattern.test(email.trim());
};
